import React from 'react';
import { Typography } from '@mui/material';
import { Patient } from 'types/patient';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import StatusChip from 'components/data-grid/StatusChip';
import { patientTableTemplate } from '../../template/patientTableTemplate';

type PatientListTableProps = {
  patients: Patient[];
};

const NOT_INFORMED = 'Não informado';

function getValue(patient: Patient, field: string) {
  return String(patient[field as keyof Patient] ?? '') || NOT_INFORMED;
}

// Colunas de texto mostram "Não informado" quando vazias; o nome fica em destaque.
const renderCells = patientTableTemplate.reduce<Record<string, (patient: Patient) => React.ReactNode>>(
  (cells, item) => {
    cells[item.id] =
      item.id === 'formattedActive'
        ? patient => <StatusChip active={Boolean(patient.active)} label={patient.formattedActive ?? ''} />
        : patient => (
            <Typography
              variant="body2"
              noWrap
              fontWeight={item.id === 'name' ? 700 : undefined}
              title={getValue(patient, item.id)}
            >
              {getValue(patient, item.id)}
            </Typography>
          );
    return cells;
  },
  {},
);

const exportValues = patientTableTemplate.reduce<Record<string, (patient: Patient) => string>>((values, item) => {
  values[item.id] =
    item.id === 'formattedActive' ? patient => patient.formattedActive ?? '' : patient => getValue(patient, item.id);
  return values;
}, {});

const PatientListTable: React.FC<PatientListTableProps> = ({ patients }) => {
  return (
    <DataGridList
      template={patientTableTemplate}
      rows={patients}
      getRowId={row => row.id}
      renderCells={renderCells}
      exportValues={exportValues}
      getRowClassName={row => (row.active ? '' : 'inactive-row')}
      onRowClick={row => history.push(`/patients/${row.id}`)}
      fileName="pacientes"
      sheetName="Pacientes"
    />
  );
};

export default PatientListTable;
